import { Route } from 'react-router-dom';

import { PropertySetupPage } from './pages/property-setup-page.js';

export function propertySetupRoutes(): React.JSX.Element {
  return <Route path="/property-setup" element={<PropertySetupPage />} />;
}
